// extracted by mini-css-extract-plugin
export default {"container":"style_container__U8pTd","wave":"style_wave__1Oo9J","innerBox":"style_innerBox__4JsAF","tako":"style_tako__8bpCr","success":"style_success__zhVza"};